<template>
     <!-- Layout Header -->
    <a-layout-header>
        <div class="header-col header-brand">
            <h6>Order Manager</h6>
        </div>
        <div class="header-col header-nav">

            <!-- Navigation Menu For Large Screens -->
            <a-menu mode="horizontal" class="menu-large">
            </a-menu>
            <!-- / Navigation Menu For Large Screens -->

            <!-- Collapsible Navigation Menu For Small Screens -->
            <div class="menu-small">

                <!-- Collapsible Component For Navigation Menu For Small Screens -->

                <!-- /Collapsible Component For Navigation Menu For Small Screens -->
            </div>
            <!-- /Collapsible Navigation Menu For Small Screens -->


        </div>
        <div class="header-col header-btn">
        </div>
    </a-layout-header>
    <!-- /Layout Header -->
</template>

<script>
export default {
    props : {
        navbarFixed : {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            top: 0,
            wrapper : document.body
        }
    },
    methods : {
        resizeEventHandler () {
            this.top = this.top ? 0 : -0.01;
        },
        
    },

    mounted() {
        this.wrapper = document.getElementById('layout-dashboard');
    },

    created() {
        window.addEventListener('resize', this.resizeEventHandler);
    },

    destroyed() {
        window.removeEventListener('resize', this.resizeEventHandler);
    }

}
</script>